module.exports = __webpack_public_path__ + "img/pic_name_ll.ee28b78a.png";